import React from 'react';
import dayjs from 'dayjs';
import { AppButton } from '@/components/atoms';
import { ChevronLeft, ChevronRight } from '@/components/atoms/AppIcon';
import { MASSAGER_JA } from '@/shared/i18n/massager';
import { convertWarekiWrap } from '@/utils/wareki';

export interface DateNavigatorProps {
  /** YYYY-MM-DD */
  value: string;
  onChange: (next: string) => void;
}

/**
 * Date navigator: [前日] [label] [翌日]. Fully responsive — label collapses
 * gracefully on narrow viewports.
 */
const DateNavigator: React.FC<DateNavigatorProps> = ({ value, onChange }) => {
  const current = dayjs(value);
  const label = current.isValid() ? convertWarekiWrap(current.format('YYYY/MM/DD')) : value;

  const go = (days: number) =>
    onChange(current.isValid() ? current.add(days, 'day').format('YYYY-MM-DD') : value);

  return (
    <div className="flex items-center justify-between gap-2 px-2 py-3 sm:px-3">
      <AppButton type="text" size="large" className="!px-2 font-medium text-gray-800" onClick={() => go(-1)}>
        <ChevronLeft /> {MASSAGER_JA.action.prevDay}
      </AppButton>

      <div className="flex flex-1 flex-col items-center">
        <span className="text-sm font-semibold text-gray-800 sm:text-base">{label}</span>
      </div>

      <AppButton type="text" size="large" className="!px-2 font-medium text-gray-800" onClick={() => go(1)}>
        {MASSAGER_JA.action.nextDay} <ChevronRight />
      </AppButton>
    </div>
  );
};

export default DateNavigator;
